import {
  IndividualResult,
  LastStudentResponse,
  Student,
} from '../classroom.constants';
import { getStudentDisplayName } from 'approot/students/logic/get-student-display-name';
import { sortIndividualResults } from '../logic/sort-individual-results';
import type { InteractiveResponseAnswerFragment } from '../../present/activity-answers.graphql.generated';
import type { AnswerFragment } from '../../present/activity-answers.graphql.generated';

type IndividualResultWithAnswer = IndividualResult & {
  answer: InteractiveResponseAnswerFragment | null;
};

export function prepareResultsPerStudent({
  studentsInClass,
  lastStudentResponses,
}: {
  studentsInClass: Student[];
  lastStudentResponses: LastStudentResponse[];
}): IndividualResultWithAnswer[] {
  const results = studentsInClass.map(student => {
    const response = lastStudentResponses.find(
      ({ studentId }) => studentId === student.id
    );

    if (response) {
      const selectedAnswerOptions = (
        response.lastAnswer?.answer as InteractiveResponseAnswerFragment
      ).interactiveResponseItems;

      const isCorrect = selectedAnswerOptions.every(
        ({ isCorrect }) => isCorrect
      );

      return {
        studentId: student.id,
        studentName: getStudentDisplayName(student),
        studentEmoji: student.emeji,
        isCorrect,
        isPending: false,
        attempts: response.numberOfAttempts,
        answer: response.lastAnswer
          ?.answer as InteractiveResponseAnswerFragment,
      };
    }

    return {
      studentId: student.id,
      studentName: getStudentDisplayName(student),
      studentEmoji: student.emeji,
      isCorrect: false,
      isPending: true,
      attempts: 0,
      answer: null,
    };
  });

  return sortIndividualResults(results);
}

export function getInteractiveResponseStudentAnswerCount(
  answers: AnswerFragment[]
): number {
  const studentIds = new Set<number>();

  answers.forEach(response => {
    if (
      response.studentId &&
      (response.answer as InteractiveResponseAnswerFragment)
        ?.interactiveResponseItems?.length > 0
    ) {
      studentIds.add(response.studentId);
    }
  });

  return studentIds.size;
}
